import { createContext, useContext } from "react";
import { DashboardStoreInterface } from "../model/dashboard.types";
import useDashboardStore from "../lib/dashboard.store";

const DashboardContext = createContext<DashboardStoreInterface | null>(null);

const DashboardProvider = ({ children }: { children: React.ReactNode }) => {
  const store = useDashboardStore();
  return (
    <DashboardContext.Provider value={store}>
      {children}
    </DashboardContext.Provider>
  );
};

const useDashboardContext = () => {
  const ctx = useContext(DashboardContext);
  if (!ctx) throw new Error("useDashboardContext must be used within DashboardProvider");
  return ctx;
};

export { DashboardProvider, useDashboardContext };